import { render, staticRenderFns } from "./platformCouponsBuyRecord.vue?vue&type=template&id=a6a9ede0&scoped=true"
import script from "./platformCouponsBuyRecord.vue?vue&type=script&lang=ts"
export * from "./platformCouponsBuyRecord.vue?vue&type=script&lang=ts"
import style0 from "./platformCouponsBuyRecord.vue?vue&type=style&index=0&id=a6a9ede0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a9ede0",
  null
  
)

export default component.exports